<template>
  <v-container
    id="login-account"
    class="fill-height justify-center"

    tag="section"
  >
    <v-row
      v-if="!loading"
      justify="center"
    >
      <v-slide-y-transition appear>
        <base-material-card

          :color="alert?.active ? 'red' : 'success'"
          :icon="alert?.active?'mdi-alert':'mdi-lock'"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-if="alert?.active ">
            <p
              class="ma-8"
              v-html="alert.html_text"
            />
          </template>
          <v-form
            v-else
            ref="formLogin"
            v-model="valid"
            lazy-validation
          >
            <v-card-text class="text-center">
              <div class="text-center grey--text text-body-1 font-weight-light mb-12">
                <v-img
                  src="@/assets/logo.png"
                  height="45"
                  contain
                />
                <!-- <h2 class="my-3">
                  {{ $siteTitle }}
                </h2> -->
              </div>

              <div class="text-left text-caption font-weight-light mt-3">
                <span style="color:#CCC">{{ $t('user_text') }}</span>
                <v-text-field
                  ref="userinput"
                  v-model="model.username"
                  style="background-color:#eee5; border-radius:3px; padding:3px;"
                  class="mt-0 pt-0"

                  type="text"
                  append-icon="mdi-account"
                  required
                  :rules="[rules.required]"
                />
              </div>
              <div
                class="text-left text-caption font-weight-light mt-3"
              >
                <span style="color:#CCC">{{ $t('password_text') }}</span>
                <v-text-field
                  ref="pwdinput"
                  v-model="model.password"
                  style="background-color:#eee5; border-radius:3px; padding:3px;"
                  class="mt-0 pt-0"
                  autocomplete="null"
                  autofocus

                  hint="At least 8 characters"
                  :type="showpwd ? 'text' : 'password'"
                  required
                  :rules="[rules.required,rules.min]"
                  :append-icon="showpwd ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showpwd = !showpwd"
                  @keyup.enter="tryLogin"
                />
              </div>
              <br>
              <v-btn
                large
                color=""
                depressed
                class="v-btn--text success--text"
                :disabled="!valid"
                @click="tryLogin"
              >
                Enter
              </v-btn>
            </v-card-text>
          </v-form>

          <div
            class="pt-5"
            style="color:#efefef"
          >
            by XsPAND.iT <small>ver: {{ appver }}</small>
          </div>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
    <v-progress-circular
      v-else
      color="primary"
      indeterminate
      size="64"
    />
  </v-container>
</template>

<script>
  import router from '@/router'
  import auth from '@/plugins/auth.js'
  import { mapState, mapActions } from 'vuex'
  import Config from '@/config.js'
  import engine from '@/plugins/engine'
  // import md5 from 'md5'
  export default {
    name: 'LoginPage',

    components: {

    },

    data () {
      return {
        appver: Config.appver,
        prompt: false,
        token: null,
        model: {
          username: '',
          password: '',
          rememberme: true,
          package_version: process.env.PACKAGE_VERSION || '0',
        },
        loginErrata: false,
        valid: true,
        showpwd: false,
        rules: {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 6) || 'Min 6 characters',
        },
        loading: false,
        alert: null,
      }
    },
    computed: {
      ...mapState(['auth']),

      get_auth: function () {
        return this.$store.state.auth
      },
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    created () {
      if (this.$workbox) {
        this.$workbox.addEventListener('worker-waiting', () => {
          this.prompt = true
        })
      }
    },
    mounted () {
      this.token = this.$token
      this.check_alert()
    },
    methods: {
      ...mapActions(['storeAuth']),
      check_alert: function () {
        this.loading = true
        engine.check_alert()
          .then((response) => {
            console.log('alert', response, this.token)
            this.alert = response.alert
          })
          .finally(() => {
            this.loading = false
          })
      },
      tryLogin: function () {
        if (!this.model.username || this.model.username.trim() === '' || !this.model.password || this.model.password.trim() === '') {
          this.$store.commit('setSnack', { message: 'invalid input', color: '#c54747d4' })
          return false
        }
        auth
          .login(this.model.username, this.model.password)
          .then((response) => {
            var payload = response.json()
            if (response.status !== 200 && !payload) {
              this.$store.commit('setSnack', { message: 'Response Err: ' + response.status + ' ' + response.statusText, color: '#c54747d4' })
              this.$refs.formLogin.reset()
              // this.model.username = ''
              // this.model.password = ''
              // this.model.rememberme = false
              // this.cleanStoreWithAuthrmations()
              return undefined
            }
            // this.toggle()
            return payload
          })
          .then((jsonData) => {
            if (jsonData.error) {
              this.$store.commit('setSnack', { message: 'Error ' + jsonData.error_code + ' ' + jsonData.error_reason, color: '#c54747d4' })
              this.$refs.formLogin.resetValidation()
              return undefined
            }

            if (!jsonData.userinfo.codsog) {
              this.$store.commit('setSnack', { message: 'Error: No Auth User', color: '#c54747d4' })
              this.$refs.formLogin.resetValidation()
              return undefined
            }

            if (jsonData !== undefined && jsonData !== null && jsonData !== '') {
              this.storeAuth(jsonData)

              console.log('json_data', jsonData)
              if (!jsonData.userinfo) {
                router.push('/login')
              } else {
                sessionStorage.setItem('logged', 'true')
                router.push('/view/dashboard')
              }
            }
          })
          .catch((errore) => {
            console.log('ERRRORE:', errore)
            this.$store.commit('setSnack', { message: 'General Error', color: '#c54747d4' })
            this.$refs.formLogin.resetValidation()
          })
      },
    },
  }
</script>
